export const stringify = (arg: unknown) => typeof arg === 'string' ? arg : JSON.stringify(arg);
